import React, { useState } from "react";
import DashboardCarousel from "./dashboardCarousel/DashboardCarousel";
import NumberFormat from "react-number-format";
import { BtnPrimary } from "../../share/buttons/Btn";
import DashCard from "../../share/cards/DashCard";
import { Bar } from "react-chartjs-2";
import { defaults } from "chart.js";
import { Chart as chartJS } from "chart.js/auto";
import Breadcrumb from "../../share/breadcrumb/Breadcrumb";
import useFetch from "../../../Hooks/useFetch";
import Cookies from "js-cookie";

const Dashboard = () => {
    const [barData, setBarData] = useState(1);
    const [courses, setCourses] = useState();

    const currentCourse = useFetch({
        method: "GET",
        url: "BootCampService/admin_current_bootcamp",
        noHeader: false,
        trigger: true,
        setter: setCourses,
    });

    let data = {
        labels:
            barData == 1
                ? barData1?.map((data) => data.month)
                : barData2?.map((data) => data.month),
        datasets: [
            {
                id: 1,
                label: "درآمد",
                data:
                    barData == 1
                        ? barData1?.map((data) => data.gain)
                        : barData2?.map((data) => data.gain),
                backgroundColor: ["#EAD0AD"],
            },
            {
                id: 2,
                label: "پرداخت",
                data:
                    barData == 1
                        ? barData1?.map((data) => data.lose)
                        : barData2?.map((data) => data.lose),
                backgroundColor: ["#D8AECA"],
            },
        ],
    };

    return (
        <>
            <div>
                <h2 className=" text-[2.4rem] text-purple-dark font-medium mb-12">
                    {Cookies.get("username")}، خوش آمدید
                </h2>
                <h4 className=" text-[2rem] text-black-prim font-bold mb-16">
                    دوره‌های جاری
                </h4>
                <div className="w-4/5 text-center mx-auto ">
                    <DashboardCarousel courses={courses?.results} />
                </div>
                <h4 className=" font-bold text-[2rem] ">گزارشات مالی</h4>
                <div className=" grid grid-cols-12 gap-10">
                    <DashCard
                        topLeft
                        bottomRight
                        className="flex flex-col justify-center items-center col-span-4 py-14 px-8"
                    >
                        <h5 className="text-[1.8rem] text-purple-dark mb-9">
                            موجودی کیف پول
                        </h5>
                        <NumberFormat
                            thousandsGroupStyle="thousand"
                            value="1500000"
                            suffix="تومان"
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                            className="text-[1.8rem] mb-9"
                        />
                        <BtnPrimary text="شارژ کیف پول" className="px-4 py-7" />
                    </DashCard>
                    <DashCard
                        topLeft
                        className="col-span-8 p-12 overflow-hidden flex flex-col justify-center items-center"
                    >
                        <select
                            onChange={(e) => {
                                setBarData(e.target.value);
                            }}
                            className="font-bold mb-3 max-w-md bg-transparent border-gray border-2 rounded-3xl w-full h-16 text-[1.1rem] text-gray"
                        >
                            <option value="1">
                                طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های
                                دولتی
                            </option>
                            <option value="2">
                                طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های
                                خصوصی
                            </option>
                        </select>
                        <Bar options={options} data={data} />
                    </DashCard>
                </div>
            </div>
        </>
    );
};

export default Dashboard;

const user = { id: "دانشگاه صنعتی اصفهان" };

export const course = [
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 20,
    },
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 50,
    },
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 80,
    },
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 0,
    },
];

const barData1 = [
    {
        id: 1,
        month: "فروردین",
        gain: 100000,
        lose: 50000,
    },
    {
        id: 1,
        month: "اردیبهشت",
        gain: 100000,
        lose: 50000,
    },
    {
        id: 1,
        month: "خرداد",
        gain: 100000,
        lose: 50000,
    },
    {
        id: 1,
        month: "تیر",
        gain: 100000,
        lose: 90000,
    },
];

const barData2 = [
    {
        id: 2,
        month: "فروردین",
        gain: 45000,
        lose: 60000,
    },
    {
        id: 2,
        month: "اردیبهشت",
        gain: 20000,
        lose: 10000,
    },
    {
        id: 2,
        month: "خرداد",
        gain: 100000,
        lose: 50000,
    },
    {
        id: 2,
        month: "تیر",
        gain: 80000,
        lose: 30000,
    },
];

//Chart customizations
defaults.font.family = "Vazir";
defaults.color = "black";
defaults.borderColor = "black";
//defaults.font.size = "15rem";

export const options = {
    scales: {
        xAxis: {
            ticks: { font: { size: 15.5 } },
            grid: { display: false },
        },
        yAxis: {
            ticks: { font: { size: 15 } },
            grid: { display: false },
            title: { display: true, text: "مبلغ (تومان)", font: { size: 16 } },
        },
    },
    responsive: true,
    plugins: {
        legend: {
            labels: {
                font: {
                    size: 14,
                },
            },
        },
    },
};
